import React from 'react';
import { TextFieldProps } from '@material-ui/core/TextField';
import { NumberFormatProps } from 'react-number-format';
import { makeStyles, createStyles } from '@material-ui/core';
import cn from 'classnames';
import NumberFormatCustom from './NumberFormatCustom';
import TextField from '../TextField/TextField';
import { TranquiTheme } from '../../containers/App/theme';

export type IFormattedInput = {
  format?: NumberFormatProps,
  currency?: boolean,
  phone?: boolean,
  document?: boolean,
  'data-test'?: string;
  min?: number;
  max?: number;
};

const currencyFormat = {
  thousandSeparator: true,
  isNumericString: true,
  prefix: '$ ',
  decimalSeparator: false,
};

const phoneFormat = {
  format: '### ### ####',
  mask: '_',
};

const documentFormat = {
  thousandSeparator: '.',
  isNumericString: true,
  decimalSeparator: false,
};

type IFormattedInputProps = TextFieldProps & IFormattedInput;
const FormattedInput: React.FC<IFormattedInputProps> = (props) => {
  const {
    className,
    inputProps = {},
    currency,
    phone,
    document,
    disabled,
    min,
    max,
    format: ogFormat = {},
    ...other
  } = props;
  const format = (() => {
    if (currency) return { ...currencyFormat, ...ogFormat };
    if (phone) return { ...phoneFormat, ...ogFormat };
    if (document) return { ...documentFormat, ...ogFormat };
    return ogFormat;
  })();
  const placeholder = other.placeholder || (currency ? '$' : undefined);
  // eslint-disable-next-line @typescript-eslint/no-use-before-define
  const classes = useStyles();

  return (
    <TextField
      // eslint-disable-next-line react/jsx-props-no-spreading
      {...other}
      placeholder={placeholder}
      className={cn(classes.root, disabled && classes.disabled, className)}
      variant="outlined"
      disabled={disabled}
      InputProps={{
        inputComponent: NumberFormatCustom as any,
        ...(inputProps as any),
      }}
      inputProps={{
        format,
        min,
        max,
      }}
      type={undefined}
    />
  );
};

const useStyles = makeStyles((theme: TranquiTheme) => createStyles({
  root: {
    '& .MuiFormLabel-root': {
      '&.Mui-focused': {
        color: theme.palette.black.main,
      },
    },
    '& .MuiOutlinedInput-root': {
      '&.Mui-focused': {
        '& .MuiOutlinedInput-notchedOutline': {
          borderColor: theme.palette.secondary.main,
          borderWidth: '1px',

        },
      },
    },
  },
  disabled: {
    '& .MuiFormLabel-root': {
      color: 'rgba(0, 0, 0, 0.26)',
    },
  },
}));
export default FormattedInput;
